<template>
  <div>
    <div
      :class="{
        downloadFile: true,
        downloadFile2: !isOpen,
      }"
      v-show="$store.state.showDownloadFile"
    >
      <div
        :class="{
          'df-header': true,
          'df-header2': !isOpen,
        }"
      >
        <div class="left">
          <span :class="modeFlag == 1 ? 'ispt' : ''">{{ fd_title }}</span>
          <div
            class="downIng2"
            v-if="modeFlag == 1 && allSpeed && hasActiveDownloads"
          >
            ·高速下载中{{ allSpeed }}MB/s
          </div>
        </div>
        <div class="right">
          <fm-button
            class="up"
            :class="{ select: true, rotated: !isOpen }"
            @click="isOpen = !isOpen"
            type="info"
            size="mini"
            text
            icon="icon-gfans-select"
          ></fm-button>
          <fm-button
            @click="closeModel"
            type="info"
            size="mini"
            text
            icon="icon-model-close"
          ></fm-button>
        </div>
      </div>
      <div class="df-box-h" v-show="downloadData.length > 0 && isOpen">
        <div
          class="df-content"
          v-for="(item, index) in downloadData"
          :key="item.findex"
        >
          <div class="df-c-left">
            <!-- 文件图片 -->
            <img :src="$utils.fileIcon(item.type)" />
            <div class="oneBox">
              <!-- 文件名 -->
              <span class="fileName">{{ item.name }}</span>
              <div class="twoBox">
                <!-- 文件大小 -->
                <span class="desc"
                  >{{ $utils.bytesToSize(item.currentSize) }} /
                  {{ $utils.bytesToSize(item.fileSize) }}</span
                >
                <!-- 剩余时间 -->
                <span
                  class="desc time"
                  v-if="!item.iscomplete && !item.isFail && !item.isWaiting"
                  >{{
                    item.surplusSecond === '00:00:NaN'
                      ? '00:00:00'
                      : item.surplusSecond
                  }}</span
                >

                <!-- 下载速度 -->
                <span
                  class="speed time"
                  v-if="!item.iscomplete && !item.isFail && !item.isWaiting"
                  >{{ item.dfcurrentSpeed }}MB/s</span
                >
                <!-- 下载完成状态 -->
                <span
                  :class="{
                    statusFont: true,
                    statusFont2: item.iscomplete && !item.isFail,
                    statusFont3: !item.iscomplete && item.isFail,
                  }"
                  >{{
                    item.iscomplete && !item.isFail
                      ? '已完成'
                      : !item.iscomplete && item.isFail
                      ? '下载失败'
                      : item.isWaiting
                      ? '排队中'
                      : ''
                  }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="bg-line"
            v-if="!item.iscomplete && !item.isFail && !item.isWaiting"
            :style="{ width: item.downloadProgress + '%' }"
          ></div>
          <div
            v-if="!item.iscomplete && !item.isFail && !item.isWaiting"
            class="line"
            :style="{ width: item.downloadProgress + '%' }"
          ></div>
          <div class="df-c-right">
            <!-- 下载重试按钮 -->
            <el-tooltip effect="dark" content="重试" placement="top">
              <fm-button
                class="rightBt"
                @click="reloadDown(item)"
                type="info"
                size="mini"
                text
                icon="icon-down-restart"
                v-show="item.isFail"
              ></fm-button>
            </el-tooltip>
            <!-- 删除和取消按钮 -->
            <el-tooltip
              effect="dark"
              :content="item.iscomplete ? '删除' : '取消'"
              placement="top"
            >
              <fm-button
                class="rightBt"
                @click="stopDownload(item, index)"
                type="info"
                size="mini"
                text
                :icon="item.iscomplete ? 'icon-down-delete' : 'icon-down-close'"
              ></fm-button>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="notDown" v-show="downloadData.length == 0 && isOpen">
        <img
          class="noneIcon"
          :src="
            $utils.getPng(
              $store.state.theme == 'light'
                ? 'icon-gfans-none'
                : 'icon-gfans-none-dark'
            )
          "
        />
        <span class="noneFont">暂无下载记录</span>
      </div>
      <div class="df-bottom" v-show="isOpen">
        <span>有任务进行时请勿刷新网页</span>
      </div>
    </div>

    <!-- 功能使用提示 -->
    <ConsumeRmBox
      @govip="govip"
      :isShowModel="isShowConsumeBox"
      :curtailInfo="curtailInfo"
      @handleClose="isShowConsumeBox = false"
      @confirmDo="confirmDo"
    ></ConsumeRmBox>
    <!-- 去app扫码验证  -->
    <VerifyModel
      :verifyLoading="verifyLoading"
      :isShowModel="isShowVerify"
      @handleClose="isShowVerify = false"
      :noWaitQRCode="noWaitQRCode"
      :isVerifyRefresh="isVerifyRefresh"
      @refresh="appVerify"
    ></VerifyModel>
    <!-- 消息提示 -->
    <PromptTip
      @confirm="confirm"
      @handleClose="handleClose"
      :tips="tips"
      :isShow="isShow"
    />
  </div>
</template>

<script>
import ConsumeRmBox from '@/components/jmCloud/ConsumeRmBox'
import VerifyModel from '@/components/VerifyModel'
import PromptTip from '@/components/PromptTip/index'
import TheSpeed from '@/utils/speedometer'
import {
  userMsg,
  userMsg2,
  userMsg3,
  userMsg4,
  userMsg5,
  userMsg6,
  retryDownAPI,
} from '@/axios/home'
import { eventBus } from '@/utils/event-bus'
export default {
  components: {
    ConsumeRmBox,
    VerifyModel,
    PromptTip,
  },
  data() {
    return {
      fd_title: '',
      downloadData: [],
      showSmall: false,
      surplusNum: 0, //正在下载中文件数量
      isShowConsumeBox: false, //消耗弹框
      curtailInfo: {},
      isShowVerify: false, //安全验证弹框
      verifyLoading: false,
      noWaitQRCode: '',
      noWaitTimer: null,
      isVerifyRefresh: false,
      accessid: '', //安全验证id
      handleItem: {},
      msgType: '',
      isCancel: false,
      downInfo: {},
      modeFlag: this.$store.state.isDownloadStyles, //标识为1时展示新样式，为0展示默认样式
      showBtn: false,
      isOpen: true,
      isShow: false, //消息提示
      tips: '', //弹窗文案
      tipType: 1, //1是关闭大弹窗，2是关闭某一行
      zcItem: {},
      zcIndex: '',
    }
  },
  watch: {
    showbox: {
      handler(val) {
        this.modeFlag = this.$store.state.isDownloadStyles
      },
    },
  },
  computed: {
    allSpeed() {
      var sum = 0
      for (var i = this.downloadData.length - 1; i >= 0; i--) {
        let _obj = this.downloadData[i]
        if (
          _obj.theSpeed &&
          !_obj.iscomplete &&
          !_obj.isAbort &&
          !_obj.isFail
        ) {
          sum += Number(this.downloadData[i].dfcurrentSpeed)
        }
      }
      return sum > 0 ? sum.toFixed(2) : '0.00'
    },
    //判断是否有正在下载的任务
    hasActiveDownloads() {
      return this.downloadData.some(item => {
        // 正在下载的条件：未完成、未失败、非排队中
        return !item.iscomplete && !item.isFail && !item.isWaiting
      })
    },
    tit_watch() {
      return this.downInfo.title
    },
    showbox() {
      return this.$store.state.showDownloadFile
    },
  },
  beforeDestroy() {
    this.downloadData.forEach(item => {
      if (item.xmlHttp) {
        item.xmlHttp.abort()
        item.xmlHttp = null
      }
    })
  },
  mounted() {
    //下载方法 橘猫云
    this.$store.commit('setAttr', {
      name: 'getDownloadFile',
      val: this.fileDown,
    })
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
    // window.onbeforeunload = (evente)=> {
    //     console.log(evente);
    //     if (this.downloadData.length > 0) {
    //     for (var i = 0; i < this.downloadData.length; i++) {
    //         console.log('上传失败',this.downloadData[i]);
    //         this.$reporte.setReporteThree(217,this.downloadData[i].fid);
    //       }
    //     }
    // };
    if (this.downloadData.length == 0) {
      this.$store.commit('setAttr', {
        name: 'showDownloadFile',
        val: false,
      })
      this.$store.commit('setAttr', {
        name: 'surplusNum',
        val: 0,
      })
    }
  },
  methods: {
    fileDown(opt) {
      this.downInfo = opt.value
      // 关闭上传弹框
      this.$store.commit('setAttr', {
        name: 'showJmUploadlayer',
        val: false,
      })
      this.$store.commit('setAttr', {
        name: 'showuploadlayer',
        val: false,
      })
      // 关闭解压弹框
      this.$store.commit('setAttr', { name: 'showPressionList', val: false })
      this.fd_title = opt.value.title
      var i = this.getDowmloadFileNum()
      // if (i > 4) {
      //   this.$toast('最多同时进行5个下载任务', 4)
      //   return
      // }
      if (opt.value.typeid == 219) {
        this.$reporte.setReporteThree(219, opt.value.fid)
      }
      this.surplusNum = i + 1
      this.$store.commit('setAttr', {
        name: 'surplusNum',
        val: this.surplusNum,
      })
      var str = opt.value.url
      var auth_key = this.getUrlParms(str, 'auth_key')
      this.isCancel = false
      let findex = new Date().getTime() + '' + this.downloadData.length
      // 检查正在下载的任务数量（非排队状态）
      const activeDownloads = this.downloadData.filter(
        item => !item.iscomplete && !item.isFail && !item.isWaiting
      ).length

      // 新任务默认设为排队状态
      const isWaiting = activeDownloads >= 3
      this.downloadData.unshift({
        typeid: opt.value.typeid || '',
        fid: opt.value.fid,
        type: opt.value.fileType,
        name: opt.value.fileName,
        fileSize: opt.value.fileSize, //文件大小
        downloadProgress: 0, //下载进度
        currentSize: 0, //当前已下载大小
        surplusSecond: 0, //剩余下载时间
        dfcurrentSpeed: 0, //当前下载速度
        surplusSize: 0, //剩余下载大小
        lastDataSize: 0, //上一秒加载的大小
        size: 0, //跟上一秒的差值
        myInterval: '',
        spLength: 0,
        iscomplete: false, //是否下载完成
        xmlHttp: '',
        isAbort: false, //是否取消终止下载
        isFail: false, //是否下载失败
        url: opt.value.url, //下载链接
        auth_key: auth_key,
        findex,
        isWaiting: isWaiting, // 新增
        addTime: Date.now(), // 新增
      })

      this.$store.commit('setAttr', {
        name: 'showDownloadFile',
        val: true,
      })
      // 只有非排队任务才立即开始下载
      if (!isWaiting) {
        this.downloadfile(
          opt.value.url,
          opt.value.fileName,
          'application/octet-stream',
          findex
        )
      }
    },
    //下载文件
    downloadfile(url, strFileName, strMimeType, findex) {
      var that = this
      let xmlHttp = null
      if (window.ActiveXObject) {
        // IE6, IE5 浏览器执行代码
        xmlHttp = new ActiveXObject('Microsoft.XMLHTTP')
      } else if (window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
        xmlHttp = new XMLHttpRequest()
      }
      const taskIndex = that.downloadData.findIndex(
        item => item.findex == findex
      )
      if (taskIndex === -1) {
        console.error('未找到匹配的下载任务:', findex)
        return
      }

      xmlHttp.findex = findex
      that.downloadData[taskIndex].xmlHttp = xmlHttp
      that.startInterval(findex, xmlHttp)
      //2.如果实例化成功，就调用open（）方法：
      if (xmlHttp != null) {
        xmlHttp.open('get', url, true)
        xmlHttp.responseType = 'blob' //关键
        xmlHttp.send()
        xmlHttp.onreadystatechange = doResult //设置回调函数
      }
      function doResult() {
        if (xmlHttp.readyState == 4) {
          //4表示执行完成
          if (xmlHttp.status == 200) {
            //200表示执行成功
            if (window.download) {
              window.download(xmlHttp.response, strFileName, strMimeType)
            }
            // let str=xmlHttp.responseURL
            // let key=that.getUrlParms(str,'auth_key')
            for (let i = 0; i < that.downloadData.length; i++) {
              if (findex === that.downloadData[i].findex) {
                // clearInterval(that.downloadData[i].myInterval)
                that.downloadData[i].iscomplete = true
                that.downloadData[i].dfcurrentSpeed = 0
                if (that.downloadData[i].theSpeed) {
                  that.downloadData[i].theSpeed.clearSpeed()
                  that.downloadData[i].theSpeed = null
                }
              }
            }
            that.surplusNum = that.getDowmloadFileNum()
            if (that.downloadData.every(f => f.iscomplete)) {
              // that.$store.commit('setAttr', {
              //   name: 'showDownloadFile',
              //   val: false,
              // })
              // that.downloadData = [] //清空数组
              that.showSmall = false
            }
          } else {
            for (let i = 0; i < that.downloadData.length; i++) {
              if (that.downloadData[i].findex === findex) {
                that.downloadData[i].isFail = true
                that.downloadData[i].dfcurrentSpeed = 0
                if (that.downloadData[i].theSpeed) {
                  that.downloadData[i].theSpeed.clearSpeed()
                  that.downloadData[i].theSpeed = null
                }
                if (that.downloadData[i].typeid == 222) {
                  that.$reporte.setReporteThree(223, that.downloadData[i].fid)
                } else if (that.downloadData[i].typeid == 219) {
                  that.$reporte.setReporteThree(
                    220,
                    that.downloadData[i].fid,
                    that.isCancel
                      ? 10001
                      : xmlHttp.status == 0
                      ? 10000
                      : xmlHttp.status + ',' + xmlHttp.statusText
                  )
                } else if (that.downloadData[i].typeid == 215) {
                  that.$reporte.setReporteThree(
                    216,
                    that.downloadData[i].fid,
                    that.isCancel
                      ? 10001
                      : xmlHttp.status == 0
                      ? 10000
                      : xmlHttp.status + ',' + xmlHttp.statusText
                  )
                } else {
                  that.$reporte.setReporteThree(
                    220,
                    that.downloadData[i].fid,
                    that.downloadData[i].fid,
                    that.isCancel
                      ? 10001
                      : xmlHttp.status == 0
                      ? 10000
                      : xmlHttp.status + ',' + xmlHttp.statusText
                  )
                }
              }
            }
          }
          that.checkQueue()
        }
      }
    },
    checkQueue() {
      // 获取活跃下载任务数
      const activeDownloads = this.downloadData.filter(
        item => !item.iscomplete && !item.isFail && !item.isWaiting
      ).length

      // 有空闲位置时启动排队任务
      if (activeDownloads < 3) {
        // 找到最早添加的排队任务
        const waitingTask = this.downloadData
          .filter(item => item.isWaiting)
          .sort((a, b) => a.addTime - b.addTime)[0]

        if (waitingTask) {
          // 启动任务
          const index = this.downloadData.indexOf(waitingTask)
          this.downloadData[index].isWaiting = false
          this.downloadfile(
            waitingTask.url,
            waitingTask.name,
            'application/octet-stream',
            waitingTask.findex
          )
        }
      }
    },
    // startInterval 方法
    startInterval(findex, xmlHttp) {
      let that = this
      const itemIndex = this.downloadData.findIndex(
        item => item.findex == findex
      )
      if (itemIndex !== -1) {
        const currentItem = this.downloadData[itemIndex]
        currentItem.theSpeed = new TheSpeed()
        currentItem.theSpeed.initSpeed(_speed => {
          currentItem.dfcurrentSpeed = (_speed / 1024 / 1024).toFixed(2) //当前速度
          currentItem.surplusSecond = that.$utils.formatSeconds(
            currentItem.surplusSize / _speed
          ) //剩余时间
          currentItem.size = 0
        })
        xmlHttp.addEventListener(
          'progress',
          function (evt) {
            if (evt.lengthComputable) {
              if (currentItem) {
                // let str=evt.currentTarget.responseURL
                // let key =that.getUrlParms(str,'auth_key')
                // if(key==that.downloadData[index].auth_key){

                if (evt.target.findex == currentItem.findex) {
                  let transfer = evt.loaded - currentItem.currentSize
                  currentItem.theSpeed.spLength += transfer
                  currentItem.currentSize = evt.loaded
                  let percentComplete = evt.loaded / evt.total //获取进度
                  currentItem.downloadProgress = (
                    percentComplete * 100
                  ).toFixed(1)
                  currentItem.surplusSize = evt.total - evt.loaded //剩余大小
                  let sizeModify = evt.loaded - currentItem.lastDataSize //避免网络不行出现负数。。
                  if (sizeModify) {
                    currentItem.size += sizeModify
                  }
                  currentItem.lastDataSize = evt.loaded
                }
              }
            }
          },
          false
        )
      }
    },
    getUrlParms(url, parameterName) {
      parameterName = parameterName.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + parameterName + '(=([^&#]*)|&|#|$)')
      var results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    stopDownload(item, index) {
      if (
        (item.iscomplete && !item.isFail) ||
        (!item.iscomplete && item.isFail)
      ) {
        //这是已完成和下载失败的情况直接删
        this.cancelDownload(item, index)
      } else {
        this.tips = '确定要取消该任务？'
        this.tipType = 2
        this.zcItem = item
        this.zcIndex = index
        this.isShow = true
      }
    },
    //取消下载
    cancelDownload(item, index) {
      this.isCancel = false
      if (this.downloadData[index].typeid == 222) {
        this.$reporte.setReporteThree(224, item.fid)
      } else if (this.downloadData[index].typeid == 219) {
        this.isCancel = true
        this.$reporte.setReporteThree(221, item.fid)
      } else if (this.downloadData[index].typeid == 215) {
        this.isCancel = true
        this.$reporte.setReporteThree(217, item.fid)
      } else {
        this.isCancel = true
        this.$reporte.setReporteThree(221, item.fid)
      }
      this.downloadData[index].isAbort = true
      this.downloadData[index].iscomplete = true
      item.xmlHttp.abort()
      item.isAbort = true
      item.dfcurrentSpeed = 0
      if (item.theSpeed) {
        item.theSpeed.clearSpeed()
        item.theSpeed = null
      }
      this.downloadData.splice(index, 1)
      this.surplusNum = this.getDowmloadFileNum()
      // 检查队列前确保DOM更新完成
      this.$nextTick(() => {
        this.checkQueue()
      })
      // if (this.downloadData.length < 1) {
      // this.$store.commit('setAttr', { name: 'showDownloadFile', val: false })
      // }
      // if (this.downloadData.every(f => f.iscomplete)) {
      // this.$store.commit('setAttr', {
      //   name: 'showDownloadFile',
      //   val: false,
      // })
      // this.downloadData = [] //清空数组
      // }
    },
    // 统计正在下载文件数量
    getDowmloadFileNum() {
      var num = 0
      let item = this.downloadData.map(item => {
        if (!item.iscomplete && !item.isFail && !item.isWaiting) {
          num++
        }
      })
      this.$store.commit('setAttr', {
        name: 'surplusNum',
        val: num,
      })
      return num
    },
    beforeunloadHandler(e) {
      if (this.downloadData.length > 0) {
        this._beforeUnload_time = new Date().getTime()
        e = e || window.event
        if (e) {
          e.returnValue = '关闭提示'
        }
        return '关闭提示'
      }
    },
    unloadHandler(e) {
      this._gap_time = new Date().getTime() - this._beforeUnload_time
      //判断是窗口关闭还是刷新
      if (this._gap_time <= 5) {
        if (this.downloadData.length > 0) {
        }
      }
    },
    confirm() {
      if (this.tipType == 1) {
        this.$store.commit('setAttr', {
          name: 'showDownloadFile',
          val: false,
        })
        this.cancelAllDownload()
      } else {
        this.cancelDownload(this.zcItem, this.zcIndex)
      }
      this.handleClose()
    },
    //关闭消息提示弹窗
    handleClose() {
      this.zcItem = {}
      this.zcIndex = ''
      this.isShow = false
    },
    closeModel() {
      let row = this.checkIncompleteItems(this.downloadData)
      if (row) {
        this.tips = '列表有未下载完的文件，确定要放弃下载吗？'
        this.tipType = 1
        this.isShow = true
      } else {
        this.$store.commit('setAttr', {
          name: 'showDownloadFile',
          val: false,
        })
        this.cancelAllDownload()
      }
    },
    checkIncompleteItems(arr) {
      // 遍历数组
      for (const item of arr) {
        // 仅处理 isFail 为 false 的对象
        if (item.isFail === false) {
          // 检查 iscomplete 是否为 false
          if (item.iscomplete === false) {
            return true // 存在符合条件的元素
          }
        }
      }
      return false // 不存在符合条件的元素
    },
    cancelAllDownload() {
      this.isCancel = true
      for (let i = this.downloadData.length - 1; i >= 0; i--) {
        let item = this.downloadData[i]
        if (item) {
          if (item.xmlHttp) {
            item.xmlHttp.abort()
            item.isAbort = true
          }
          if (item.dfcurrentSpeed) {
            item.dfcurrentSpeed = 0
          }
          if (item.theSpeed) {
            item.theSpeed.clearSpeed()
            item.theSpeed = null
          }
        }
        this.downloadData.splice(i, 1)
      }
    },
    //获取用户弹窗提示信息接口
    getUserMsg(type) {
      userMsg({ type: type }).then(res => {
        if (res.code) {
          if (res.data.msgType === '1') {
            this.$toast(res.data.msg1, 2)
          } else if (
            res.data.msgType == '2' ||
            res.data.msgType == '3' ||
            res.data.msgType == '4'
          ) {
            this.isShowConsumeBox = true
            this.curtailInfo = res.data //弹框信息
            this.msgType = res.data.msgType
          } else {
            this.cvDownload()
          }
        } else {
          this.$toast(res.msg, 2)
        }
      })
      this.$api.post(
        '/cloudFile/userMsg',
        { type: type },
        res => {
          if (res.code) {
            if (res.data.msgType === '1') {
              this.$toast(res.data.msg1, 2)
            } else if (
              res.data.msgType == '2' ||
              res.data.msgType == '3' ||
              res.data.msgType == '4'
            ) {
              this.isShowConsumeBox = true
              this.curtailInfo = res.data //弹框信息
              this.msgType = res.data.msgType
            } else {
              this.cvDownload()
            }
          } else {
            this.$toast(res.msg, 2)
          }
        },
        2
      )
    },
    //使用橘猫云会员功能接口
    useFunctionality(type) {
      userMsg2({ type: '2', msgType: this.msgType }).then(res => {
        if (res.code) {
          this.cvDownload()
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    // 确认使用次数或者福利点
    confirmDo() {
      this.handleItem.url = ''
      this.useFunctionality()
      this.isShowConsumeBox = false
    },
    //下载 判断操作是否需要安全性校验
    downloadFile(item) {
      this.handleItem = item
      // if (this.$store.state.surplusNum > 4) {
      //   this.$toast('最多同时进行5个下载任务', 4)
      //   return
      // }
      //2-橘猫云下载  13-飞猫盘下载 14-飞猫盘转存 15-扫一扫确定
      userMsg3({ accessid: '', sceneid: '2' }).then(res => {
        if (res.status == 1) {
          //1-升级橘猫云会员 2-验证通过 3-验证失败
          if (res.data.state == 1) {
            if (res.data.toast.msgType === '1') {
              this.$toast(res.data.toast.msg, 2)
            } else if (
              res.data.toast.msgType == '2' ||
              res.data.toast.msgType == '3' ||
              res.data.toast.msgType == '4'
            ) {
              this.isShowConsumeBox = true
              this.curtailInfo = res.data.toast
              this.msgType = res.data.toast.msgType
            } else {
            }
          }
          if (res.data.state == 2) {
            //去下载
            this.verifyHandle()
          }
          if (res.data.state == 3) {
            //需要扫码验证
            this.appVerify()
          }
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    //app扫码安全风险验证
    appVerify() {
      this.noWaitTimer && clearInterval(this.noWaitTimer)
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
        // let path = this.$route.path.toString().slice(1)
        // const from = 'gfans'
        // const fromUrl = this.$glb.jmdyhUrl + `/${path}`
        // const encodedFrom = encodeURIComponent(from)
        // const encodedFromUrl = encodeURIComponent(fromUrl)
        // window.location.href =
        //   this.$glb.feemooUrl +
        //   `/login?from=${encodedFrom}&fromUrl=${encodedFromUrl}`
        // return
      }
      this.isVerifyRefresh = false
      this.isShowVerify = true
      this.verifyLoading = true
      userMsg4({ state: 1 }).then(res => {
        var code = res.data
        var qr = qrcode(0, 'L')
        qr.addData(code)
        qr.make()
        this.noWaitQRCode = qr.createDataURL(10, 0)
        this.verifyLoading = false
        this.noWaitTimer = setInterval(() => {
          this.checkNoWaitQrCode(code)
        }, 5000)
      })
    },
    // app扫码状态
    checkNoWaitQrCode(data) {
      userMsg5({ state: 1, code: data }).then(res => {
        if (res.status == 1) {
          let formObj = res.data
          this.noWaitTimer && clearInterval(this.noWaitTimer)
          this.accessid = formObj
          this.isShowVerify = false
          this.$toast(res.msg, 1)
          this.verifyHandle()
        } else if (res.status == '41001') {
          this.noWaitTimer && clearInterval(this.noWaitTimer)
          this.isVerifyRefresh = true
        } else {
          if (res.msg !== '') {
            this.noWaitTimer && clearInterval(this.noWaitTimer)
            this.$toast(res.msg, 2)
          }
        }
      })
    },
    //下载
    verifyHandle() {
      this.showNotSupportModel = false
      this.getUserMsg('2')
      this.myfun = 'cvDownload'
    },
    cvDownload() {
      retryDownAPI({
        file_id: this.handleItem.fid,
        url: this.handleItem.url,
      }).then(res => {
        if (res.status == 1) {
          if (this.handleItem.typeid == 222) {
            this.$reporte.setReporteThree(222, this.handleItem.fid)
          } else if (this.handleItem.typeid == 219) {
            this.$reporte.setReporteThree(219, this.handleItem.fid)
          } else {
            this.$reporte.setReporteThree(215, this.handleItem.fid)
          }
          let formObj = res.data
          this.handleItem.url = formObj.url
          this.handleItem.downloadProgress = 0
          this.handleItem.isFail = false
          this.handleItem.currentSize = 0 //当前已下载大小
          this.handleItem.surplusSecond = 0 //剩余下载时间
          this.handleItem.dfcurrentSpeed = 0 //当前下载速度
          this.handleItem.surplusSize = 0 //剩余下载大小
          this.handleItem.lastDataSize = 0 //上一秒加载的大小
          this.handleItem.size = 0 //跟上一秒的差值
          this.downloadfile(
            formObj.url,
            this.handleItem.name,
            'application/octet-stream',
            this.handleItem.findex
          )
        } else {
          // this.$toast(res.msg, 2)
        }
      })
    },
    reloadDown: _.debounce(
      function (item) {
        this.handleItem = item
        this.cvDownload()
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    govip() {
      window.open(this.$glb.feemooUrl + '/vip')
    },
  },
}
</script>
<style lang="scss" scoped>
.downIng {
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  @include useTheme {
    color: getVar('text-color13-8a8b92');
  }
}
.downIng2 {
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  @include useTheme {
    color: getVar('primary-color');
  }
}
.btnts {
  width: 64px;
  height: 24px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 24px;
  margin-left: 12px;
  cursor: pointer;
  @include useTheme {
    background: getVar('primary-color');
  }
}
.notDown {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 215px;
  .noneIcon {
    width: 80px;
    height: 80px;
    margin-bottom: 4px;
  }
  .noneFont {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    @include useTheme {
      color: getVar('text-color2-75787b');
    }
  }
}
</style>
